<template>
  <b-container fluid>
    <paywall-preview
      :placeholder="placeholder"
      :device="device"
      :config="config[device]" />
    <b-form
      ref="form"
      novalidate
      :validated="validated">
      <paywall-form-packages
        :placeholder="placeholder"
        :disabled="!canPaywallEdit"
        :config="config[device]"
        :device="device"
        config-key="packages" />
    </b-form>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex"
import PaywallFormPackages from "@/components/Paywall/PaywallFormPackages"
import PaywallPreview from "@/components/Paywall/PaywallPreview"

export default {
  name: "PaywallForm",
  components: {
    PaywallPreview,
    PaywallFormPackages,
  },
  props: {
    config: {
      type: Object,
      default: null,
      required: true,
    },
    device: {
      type: String,
      default: null,
      required: true,
    },
    placeholder: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data: () => ({
    validated: false,
  }),
  computed: {
    ...mapGetters(['canPaywallEdit']),
  },
  methods: {
    isValid() {
      this.validated = true
      return this.$refs.form.checkValidity()
    },
  },
}
</script>

<style scoped>

</style>